module.exports = __webpack_public_path__ + "static/img/banner3.ead2fa5c.png";